import { useCallback, useState } from 'react';

interface UseElementRefReturnType<TElement> {
  /**
   * The referenced element, or null if the element is not yet available.
   */
  element: TElement | null;
  /**
   * A ref to attach to the element.
   */
  ref: React.RefCallback<TElement>;
}

/**
 * Returns a callback ref to attach to an element. The referenced element is stored in React state,
 * which ensures the component is re-rendered if the ref is assigned to a different element.
 */
export const useElementRef = <TElement extends Element>(): UseElementRefReturnType<TElement> => {
  const [element, setElement] = useState<TElement | null>(null);

  const ref = useCallback((node: TElement | null) => {
    setElement(node);
  }, []);

  return { element, ref };
};
